import * as React from "react";
const SvgCreateBookLayout24 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 1080, height: 1080, viewBox: "0 0 1080 1080", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("desc", null, "Created with Fabric.js 5.2.4"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("rect", { x: 0, y: 0, width: "100%", height: "100%", fill: "transparent" }), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1 0 0 1 540 540)", id: "1ffaa493-97ae-434a-baae-d759a7d8aec9" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "none",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(255,255,255)",
  fillRule: "nonzero",
  opacity: 1,
  visibility: "hidden"
}, vectorEffect: "non-scaling-stroke", x: -540, y: -540, rx: 0, ry: 0, width: 1080, height: 1080 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1 0 0 1 540 540)", id: "b5871b1d-bc32-4b35-8fc0-094660eb2acb" }), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1 0 0 1 50 50)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "none",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(255,255,255)",
  fillOpacity: 0,
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -50, y: -50, rx: 0, ry: 0, width: 100, height: 100 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1 0 0 1 540 540)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "none",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(255,255,255)",
  fillRule: "nonzero",
  opacity: 1,
  visibility: "hidden"
}, vectorEffect: "non-scaling-stroke", x: -540, y: -540, rx: 0, ry: 0, width: 1080, height: 1080 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(16.14 0 0 16.14 540 540)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "rgb(69,92,198)",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(230,239,251)",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -33.085, y: -33.085, rx: 0, ry: 0, width: 66.17, height: 66.17 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(4.56 0 0 9.8 540.01 703.98)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "rgb(69,92,198)",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(230,239,251)",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -33.085, y: -33.085, rx: 0, ry: 0, width: 66.17, height: 66.17 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(4.57 0 0 4.51 541.52 201.94)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "rgb(69,92,198)",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(230,239,251)",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -33.085, y: -33.085, rx: 0, ry: 0, width: 66.17, height: 66.17 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(4.62 0 0 4.54 878.91 876.69)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "rgb(69,92,198)",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(230,239,251)",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -33.085, y: -33.085, rx: 0, ry: 0, width: 66.17, height: 66.17 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(4.56 0 0 9.72 878.86 373.48)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "rgb(69,92,198)",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(230,239,251)",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -33.085, y: -33.085, rx: 0, ry: 0, width: 66.17, height: 66.17 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(4.62 0 0 4.54 202.14 877.23)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "rgb(69,92,198)",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(230,239,251)",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -33.085, y: -33.085, rx: 0, ry: 0, width: 66.17, height: 66.17 })), /* @__PURE__ */ React.createElement("g", { transform: "matrix(4.56 0 0 9.72 202.05 374.15)" }, /* @__PURE__ */ React.createElement("rect", { style: {
  stroke: "rgb(69,92,198)",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  fill: "rgb(230,239,251)",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", x: -33.085, y: -33.085, rx: 0, ry: 0, width: 66.17, height: 66.17 })));
export default SvgCreateBookLayout24;
